module.exports = __webpack_public_path__ + "img/ic_32_sport_eishockey-white.a9ec195a.svg";